var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#d4efee",
    height: 23,
    rx: 11.5,
    width: 23,
    x: 0.5,
    y: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 12 3 3 7-7",
    stroke: "#408380",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 23,
    rx: 11.5,
    stroke: "#005955",
    width: 23,
    x: 0.5,
    y: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCBmaWxsPSIjZDRlZmVlIiBoZWlnaHQ9IjIzIiByeD0iMTEuNSIgd2lkdGg9IjIzIiB4PSIuNSIgeT0iLjUiLz48cGF0aCBkPSJtNyAxMiAzIDMgNy03IiBzdHJva2U9IiM0MDgzODAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+PHJlY3QgaGVpZ2h0PSIyMyIgcng9IjExLjUiIHN0cm9rZT0iIzAwNTk1NSIgd2lkdGg9IjIzIiB4PSIuNSIgeT0iLjUiLz48L3N2Zz4=";